import React from "react"

import WarningIcon from "../../components/WarningIcon"

import {Helmet} from "react-helmet";

import {connect} from "react-redux"
import {bindActionCreators} from "redux";
import * as actions from "../../actions";

import {Redirect} from "react-router-dom"
import {
    PAYMENT_OBJECT_TYPE_ORDER,
    PAYMENT_OBJECT_TYPE_TOPUP,
} from "../../constants/payment"

class CardTransactionFailed extends React.Component {

    constructor(props){
        super(props)
        const {history, user} = props
        // const paymentId = query.get("paymentId")
        // const transactionId = query.get("txnId")
        const query = new URLSearchParams(history.location.search)
        const custom = query.get("custom")
        const objectType = typeof custom === "string" ? custom.split(" ")[0] : PAYMENT_OBJECT_TYPE_ORDER
        const redirectTo = objectType === PAYMENT_OBJECT_TYPE_TOPUP ?
                            `/shopdm-credit/${user.id}`
                            :
                            `/checkout`
        this.state = {
            redirectCount: 4,
            redirectTo,
            redirectInterval: () => {},
            lastIntervalUpdate: 0
        }
    }

    componentDidMount(){
        this.triggerRedirect()
    }

    triggerRedirect = () => {
        this.setState({
            redirectInterval: setInterval(() => {
                if ((Date.now() - this.state.lastIntervalUpdate) >= 1000) this.setState({
                    redirectCount: this.state.redirectCount - 1,
                    lastIntervalUpdate: Date.now()
                })
            }, 300)
        })
    }

    componentWillUnmount(){
        if (typeof this.state.redirectInterval === 'function') this.state.redirectInterval()
    }
    render(){
        const {redirectCount, redirectTo} = this.state
        if (redirectCount <= 0) return <Redirect to={redirectTo}/>
        //generate different response titles and messages based on the response code and financial result
        let responseTitle = "Oh no, your payment failed"
        let responseMessage = "We couldn't complete your Shopdm payment. Please go back and try again."            

        return (
            <div className={["screen", "cardResultContainer"].join(" ")}>
                <Helmet>
                    <title>Card Transaction Failed</title>
                </Helmet>
                <img height="100" width="auto" src="https://firebasestorage.googleapis.com/v0/b/shop-dm.appspot.com/o/shopdm%2Flogo500x500.png?alt=media&token=9be6790b-1251-4331-945d-bc96d96ae65f" />
                <div className="cardResultInnerContainer">
                    <WarningIcon />
                    <div className="cardResultTitleContainer"> 
                        <div className="cardResultTitle">{responseTitle}</div>
                    </div>
                    <p className="cardResultNext">{responseMessage}</p>
                    <div>Redirecting you in {redirectCount}</div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => ({
    user: state.user
})

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CardTransactionFailed);